<script setup lang="ts">
import { LOCALE } from "core/interfaces";
import { capitalize } from "vue";

import { getKindLinks } from "~/common/helpers/get-kind-links";

const { t, locale } = useI18n();
const shopStore = useShopStore();

const kindLinks = computed(() => getKindLinks(locale.value as LOCALE, shopStore.components.kinds, { hash: "#gallery" }));
const tagLinks = shopStore.components.tags.map(({ id, name }) => {
	return {
		name,
		link: {
			path: "/shop",
			query: { tags: id },
			hash: "#gallery"
		}
	};
});

const informationLinks = computed(() => [
	{
		name: capitalize(t("aboutUs")),
		link: "/about"
	},
	{
		name: t("faq"),
		link: "/faq"
	},
	{
		name: t("publicOffer"),
		link: "/public-offer"
	},
	{
		name: t("privacyPolicy"),
		link: "/privacy-policy"
	}
]);
const shopLinks = computed(() =>
	[
		{
			name: capitalize(t("allProducts")),
			link: {
				path: "/shop",
				hash: "#gallery"
			}
		},
		...kindLinks.value,
		...tagLinks
	]
);
const workingHours = computed(() => [
	{
		name: t("workingHoursWeekdays"),
		link: ""
	},
	{
		name: t("workingHoursWeekend"),
		link: ""
	}
]);
</script>

<template>
	<nav class="flex justify-around w-full gap-x-11 gap-y-7 sm:justify-between xs:flex-wrap xs:justify-start">
		<LayoutFooterNavCol
			:title="t('information')"
			:links="informationLinks"
		/>
		<LayoutFooterNavCol
			:title="t('shop')"
			:links="shopLinks"
		/>
		<div>
			<LayoutFooterNavCol
				:title="t('workingHours')"
				:links="workingHours"
			/>
			<div class="mt-7 flex items-center gap-3">
				<NuxtImg
					src="img/visa-logo.svg"
					alt="Visa"
					class="h-4 w-auto"
				/>
				<NuxtImg
					src="img/mastercard-logo.svg"
					alt="Mastercard"
					class="h-5 w-auto"
				/>
			</div>
		</div>
	</nav>
</template>
